export function formatAnyPhoneNumber(number: string): string {
  const cleaned = number.toString().replace(/\D/g, '');

  if (
    cleaned.length === 11 &&
    (cleaned.startsWith('7') || cleaned.startsWith('8'))
  ) {
    return cleaned.replace(
      /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
      '+$1 ($2) $3-$4-$5',
    );
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2-$3-$4');
  } else {
    return cleaned.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
  }
}
